import React from 'react';
import styles from './CallToAction.module.scss';
import { useNavigate } from 'react-router-dom';
const CallToAction = () => {
  const navigate = useNavigate(); // Used for programmatic navigation
  const handleNavigation = () => {
    navigate('/contact'); // Specify your 'Contact Us' route here
  };
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>
      Experience alligned consulting and leverage existing and future investments at the best ROI
      </h2>
      <button className={styles.button} onClick={handleNavigation}>Contact Us</button>
    </div>
  );
};

export default CallToAction;
